import {Typography} from '@mui/material';
import Card from '@mui/material/Card';

import {FONT_FAMILIES} from '../../../../const';
import {onboardingFlowShape} from '../../../../proptypes-shapes';
import {getIconComponent} from '../../../../utils';

const OnboardingSelectFlowCard = ({flow}) => {
  const Icon = getIconComponent(flow.icon);
  return (
    <Card
      elevation={0}
      sx={{
        px: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        border: '1px solid #DEDEDE',
        borderRadius: 3,
        height: 250,
        cursor: 'pointer'
      }}
    >
      <Icon color="primary" sx={{fontSize: 45}} />

      <Typography px={1} textAlign="center" mt={2.5} fontFamily={FONT_FAMILIES.TITLE} fontSize={18}>
        {flow.title}
      </Typography>
      <Typography mt={1} fontFamily={FONT_FAMILIES.BODY} fontSize={14} color="text.secondary">
        {flow.description}
      </Typography>
    </Card>
  );
};

OnboardingSelectFlowCard.propTypes = {
  flow: onboardingFlowShape.isRequired
};

export default OnboardingSelectFlowCard;
